// @ts-nocheck

import Icons from '@/assets/icons'
import { Colors } from '@/utils/Colors'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, { VAutocomplete, VBtn, VSelect } from 'vuetify/lib'
import { pt } from 'vuetify/src/locale'

Vue.use(Vuetify)

// Vuetify default configurations
VBtn.options.props.rounded.default = true
VBtn.options.props.depressed.default = true
VAutocomplete.options.props.clearable.default = true
VAutocomplete.options.props.chips.default = false
VAutocomplete.options.props.outlined.default = true
VAutocomplete.options.props.dense.default = true
VAutocomplete.options.props.smallChips.default = false
VAutocomplete.options.props.deletableChips.default = true

VSelect.options.props.outlined.default = true
VSelect.options.props.dense.default = true
VSelect.options.props.label.default = ''
VSelect.options.props.hint.default = ''

VSelect.options.props.persistentPlaceholder.default = true

export const vuetify = new Vuetify({
	lang: {
		locales: { pt },
		current: 'pt'
	},
	theme: {
		options: {
			customProperties: true
		},
		themes: {
			light: {
				//cor quintocred
				//primary: Colors.//,
				primary: Colors.primary,
				//secondary: Colors.//,
				secondary: Colors.secondary,
				accent: Colors.accent,
				error: Colors.error,
				info: Colors.info,
				success: Colors.success,
				warning: Colors.warning,
				opacity: Colors.opacity,
				surface: Colors.surface,

				//Design System
				analysisBg: Colors.analysisBg,
				deniedBg: Colors.deniedBg,
				successBg: Colors.successBg,

				warningTextColor: Colors.warningTextColor,
				successTextColor: Colors.successTextColor,

				notificationItemBackground: Colors.notificationItemBackground
			}
		}
	},
	icons: {
		iconfont: 'md',
		values: Icons
	}
})
